export enum BookmarkEvent {
	NewBookmark = 'Bookmark Saved',
	UnsaveBookmark = 'Bookmark Un-Saved',
	AddBookmarkNote = 'Bookmark Add Note',
}

export enum BookmarkLabelEvent {
	AiSuggestedLabelSelected = 'Ai Suggested Label Selected',
	ExistingLabelSelected = 'Existing Label Selected',
	AiSuggestedLabelRemoved = 'Ai Suggested Label Removed',
	ExistingLabelRemoved = 'Existing Label Removed',
}
